<div class="container-fluid">
  <h2 class="content-block">ULAZNE FAKTURE</h2>
  <div class="content-block dnevniPlanWrapper">
    <div class="selectDates">     
      <div class="odabirDatuma">
        <label>Datum od:</label>
        <dx-date-box 
          #dateBox1
          width="200"
          id="datum" 
          type="date" 
          displayFormat='dd.MM.yyyy.' 
          [max]="datumSlanje2" 
          [(value)]="datumSlanje1" 
          (onValueChanged)="editDatum1($event)"
          (onEnterKey)="focusNext('dateBox1')">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <label>Datum do:</label>
        <dx-date-box 
          #dateBox2
          width="200" 
          id="datum" 
          type="date" 
          displayFormat='dd.MM.yyyy.' 
          [min]="datumSlanje1" 
          [(value)]="datumSlanje2" 
          (onValueChanged)="editDatum2($event)">
        </dx-date-box>
      </div>
      <div class="odabirDatuma">
        <dx-button id="refresh" icon="refresh" hint="Postavi datume od početka mjeseca do danas" (onClick)="ponistiFilter()"></dx-button>
        <label>Prikaži sve od početka mjeseca</label>
      </div>
    </div>
    <div class="customTable pregledDostavnica">
      <dx-data-grid 
        id="ufe"         
        [rowAlternationEnabled]="true"
        [showColumnLines]="true"
        [hoverStateEnabled]="true"
        [wordWrapEnabled]="true"
        [dataSource]="ulaznefakture"
        [showBorders]="true" 
        [columnAutoWidth]="true" 
        [showRowLines]="true" 
        noDataText="{{ poruka }}"
        keyExpr="uf_id"
        [focusedRowEnabled]="true"
        [autoNavigateToFocusedRow]="false"
        (onCellPrepared)="onCellPreparedUfa($event)"
        (onToolbarPreparing)="onToolbarPreparing($event)">

        <dxo-search-panel
          [visible]="true"
          [width]="210"
          placeholder="Pretraži..."
        >
        </dxo-search-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-editing
          mode="form"
          [allowUpdating]="false"
          [allowDeleting]="false"
          [allowAdding]="false">     
        </dxo-editing>

        <dxo-paging [pageSize]="30"></dxo-paging>
        <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[30, 60, 90]" [showInfo]="true" [visible]="true"></dxo-pager>
        <!-- <dxo-state-storing [enabled]="true" type="sessionStorage" storageKey="ufeKey" [savingTimeout]="0"></dxo-state-storing> -->

        <!-- <dxi-column caption="Broj UFE" cellTemplate="prikazbroja" alignment="center" [calculateCellValue]="calculateBrojUFE" [allowFiltering]="true">
            <div *dxTemplate="let data of 'prikazbroja'">
                <div>{{data.data.uf_broj}}/{{data.data.pg_godina}} </div>
            </div>
        </dxi-column> -->
        <dxi-column dataField="uf_broj" caption="Broj UFE" alignment="right" [width]="120"></dxi-column>
        <dxi-column dataField="pa_sifra" caption="Šifra"></dxi-column>
        <dxi-column dataField="pa_naziv" caption="Naziv" [width]="300"></dxi-column>
        <dxi-column dataField="uf_datum" caption="Datum dokumenta" dataType="date" alignment="center"></dxi-column>
        <dxi-column dataField="uf_valuta" caption="Dospijeće" dataType="date" alignment="center"></dxi-column>
        <dxi-column dataField="uf_iznos" caption="Iznos" [editorOptions]="{ format: { type: 'fixedPoint',  precision: 2 } }" [allowSearching]="true" dataType="string" alignment="right">
          <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
        </dxi-column>
        <dxi-column dataField="uf_porez" caption="PDV" [editorOptions]="{ format: { type: 'fixedPoint',  precision: 2 } }" [allowSearching]="true" dataType="string" alignment="right">
          <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
        </dxi-column>
        <dxi-column dataField="uf_ukupno" caption="Ukupno" [editorOptions]="{ format: { type: 'fixedPoint',  precision: 2 } }" [allowSearching]="true" dataType="string" alignment="right">
          <dxo-format type="fixedPoint" [precision]="2"> </dxo-format>
        </dxi-column>
        <dxi-column dataField="uf_brojnarudzbe" caption="Broj narudžbe" alignment="right" [width]="150"></dxi-column>
        <dxi-column dataField="korisnik_dodao" caption="Djelatnik"></dxi-column>
        <dxi-column dataField="uf_danisat" caption="Datum izrade" dataType="date" alignment="center"></dxi-column>
        <dxi-column dataField="po_naziv" caption="Skladište" [width]="250"></dxi-column>
        <dxi-column dataField="uf_datizmjene" caption="Datum izmjene" dataType="date" alignment="center"></dxi-column>
        <dxi-column dataField="korisnik_izmjene" caption="Operater izmjene"></dxi-column>
        <dxi-column dataField="uf_status" caption="Status" [width]="130" alignment="center">
          <dxo-lookup
            [dataSource]="statusArray"
            displayExpr="status_naziv"
            valueExpr="status_vrijednost">
          </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="uf_proknjizen" caption="Knjiženo" [width]="130" alignment="center">
          <dxo-lookup
            [dataSource]="knjizenoArray"
            displayExpr="knjizeno_naziv"
            valueExpr="knjizeno_vrijednost">
          </dxo-lookup>
        </dxi-column>

        <dxi-column type="buttons" alignment="left" [fixed]="true"><dxi-button template="ufabuttons"></dxi-button></dxi-column>
        <div *dxTemplate="let buttonInfo of 'ufabuttons'"> 
          <dx-button icon="print" id="racunispis" type="normal" (click)="ispisUFE(buttonInfo.data.uf_id)" hint="Ispis UFE"></dx-button>
          <dx-button *ngIf="omoguciEditiranje" icon="edit" id="btn" (click)="uredi(buttonInfo)"></dx-button>
          <dx-button *ngIf="omoguciEditiranje" icon="trash" id="btn" (click)="obrisi(buttonInfo)"></dx-button>
          <dx-button *ngIf="!omoguciEditiranje" type="normal" icon="info" (click)="prikazUFA(buttonInfo)" hint="Detalji UFE"></dx-button> 
          <dx-button *ngIf="!omoguciEditiranje && (buttonInfo.data.uf_status === 'Z' || buttonInfo.data.uf_status === 'K')" id="storno" type="normal" 
                      icon="warning" (click)="storniraj(buttonInfo)" hint="Storniraj ulaznu fakturu">
          </dx-button>
        </div>

        <div *dxTemplate="let data of 'naslovTablice'" class="grid-wrapper">
          <div class="naslov" style="margin-right: 50px; width: 200px;">
            <h2>{{ vrstaUFA }} UFE</h2>
          </div>
        </div>
        <div *dxTemplate="let data of 'zavrseno'">
          <dx-button [ngClass]="[ aktivnoBtn ? 'startAktivni' : 'aktivni' ]" text="Završeno" name="zavrseno" (onClick)="zavrseno()"></dx-button>  
        </div>
        <div *dxTemplate="let data of 'nezavrseno'">
          <dx-button [ngClass]="[ aktivnoBtn ? 'neaktivni' : 'startNeaktivni' ]"  text="Nezavršeno" name="nezavrseno" (onClick)="nezavrseno()"></dx-button>  
        </div> 
        <dxo-summary *ngIf="ulaznefakture.length > 0">
          <dxi-total-item column="pa_naziv" alignment="center" summaryType="count" displayFormat="Ukupno: {0}"  ></dxi-total-item>                         
          <dxi-total-item column="uf_osnovica" alignment="right" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }" ></dxi-total-item>       
          <dxi-total-item column="uf_porez" alignment="right" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }" ></dxi-total-item>       
          <dxi-total-item column="uf_iznos" alignment="right" summaryType="sum" displayFormat="{0}" [valueFormat]="{ type: 'fixedPoint', precision: 2 }" ></dxi-total-item>       
        </dxo-summary>
      </dx-data-grid>
    </div>
  </div>
</div>